/**
 * Generates a jittered clip-path polygon that reads as a torn-paper edge,
 * seeded by a stable id so the same element always gets the same shape
 * across re-renders (and across reloads) instead of reshuffling.
 */
function hashSeed(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  }
  return h >>> 0;
}

function mulberry32(seed) {
  let a = seed;
  return function () {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function getTornClipPath(seedId, { pointsPerEdge = 18, jitter = 2.5 } = {}) {
  const rand = mulberry32(hashSeed(seedId));
  const n = Math.max(pointsPerEdge, 2);
  const step = 100 / (n - 1);
  const near0 = () => (rand() * jitter).toFixed(1);
  const near100 = () => (100 - rand() * jitter).toFixed(1);
  const points = [];

  for (let i = 0; i < n; i++) points.push(`${(i * step).toFixed(1)}% ${near0()}%`);
  for (let i = 1; i < n; i++) points.push(`${near100()}% ${(i * step).toFixed(1)}%`);
  for (let i = 1; i < n; i++) points.push(`${(100 - i * step).toFixed(1)}% ${near100()}%`);
  for (let i = 1; i < n; i++) points.push(`${near0()}% ${(100 - i * step).toFixed(1)}%`);

  return `polygon(${points.join(", ")})`;
}
